module.exports = __webpack_public_path__ + "992d6999e2e522da817fd40a8cd3cba8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Racers/red.ss.png
// module id = 655
// module chunks = 0